/**
 * Duration of the modal's transition (animation) (in ms).
 */
export const MODAL_TRANSITION_DURATION = 300;
